import React from 'react'

const ContactSupport = () => {
  return (
    <div>ContactSupport</div>
  )
}

export default ContactSupport